<template>
  <div>
    <LoadingModal :is-loading="isLoading" custom-text="Идет загрузка"/>

    <v-form ref="form">

      <v-row class="pa-0 ma-0">
        <v-col sm="8" class="pa-0">
          <p class="pa-0 ma-0">Номер существующего индекса рода:</p>
          <v-text-field
              autocomplete="off"
              v-model="genusIndexNumber"
              :rules="indexRules"
              required
              name="title"
              clearable
              class="mt-0 pt-0"
          />
        </v-col>
        <v-col sm="2">
          <v-btn x-small fab class="align-self-center mr-3 mt-1" color="#0d47a1" @click="findGenusIndex">
            <v-icon color="white">
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-col sm="8" class="pa-0" v-if="isGenusIndexFound">
        <p class="pa-0 ma-0">Связанный с индексом список родов:</p>
        <v-combobox
            class="mt-0 pt-0"
            v-model="genusList"
            multiple
            persistent-hint
            chips
            append-icon=""
        >
          <template v-slot:append-outer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on">mdi-information</v-icon>
              </template>
              <span>
              Для добавления: поставить курсор в конец, ввести новый род, нажать Enter.<br>
              Для удаления: ЛКМ по роду, нажать backspace на клавиатуре
            </span>
            </v-tooltip>
          </template>
        </v-combobox>
      </v-col>

      <v-row class="pt-5" v-if="isGenusIndexFound">
        <v-col sm="8">
          <v-btn
              class="rounded-0"
              color="grey darken-1"
              outlined
              @click="updateGenusIndex"
          >
            сохранить изменения
          </v-btn>

          <v-btn
              class="ms-1 rounded-0"
              color="deep-orange darken-1"
              outlined
              @click="isDeletion = true"
          >
            удалить индекс рода
          </v-btn>
        </v-col>
      </v-row>

      <v-dialog
          v-model="isDeletion"
          width="auto"
          persistent
          class="rounded-0"
      >
        <v-card class="pa-5 pt-10" tile>
          <p>Вы уверены что хотите удалить этот индекс рода?</p>
          <p>(У экземпляров с этим индексом рода поля индекс рода и род будут очищены)</p>
          <v-card-text>
            <div class="d-flex justify-end">
              <v-btn tile text color="red" @click="deleteGenusIndex">да</v-btn>
              <v-btn tile text color="blue accent-4" @click="() => this.isDeletion = false">нет</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

    </v-form>
  </div>
</template>

<script>
import LoadingModal from "@/components/UI/LoadingModal";
import {findGenusIndexByIndex, updateGenusIndex, deleteGenusIndex, createGenusIndex} from "@/services/genusIndexAPI";
import ToastService from '@/services/toastService';

export default {
  name: 'IndexAndGenusEditComponent',

  components: {LoadingModal},

  data() {
    return {
      isLoading: false,
      genusIndexNumber: "",
      genusList: [],
      isGenusIndexFound: false,
      isDeletion: false,
      indexRules: [
        v => !!v || 'Поле не может быть пустым'
      ],
    }
  },

  methods: {
    async findGenusIndex() {
      if (!this.$refs.form.validate()) throw new Error(`can't miss out on any field`)
      this.isGenusIndexFound = false;
      this.isLoading = true
      await findGenusIndexByIndex(this.genusIndexNumber)
          .then((data) => {
            this.isGenusIndexFound = true;
            this.genusList = data.genusList
          })
          .catch((e) => {
            if (e.response.status === 404) {
              ToastService.toastError("Ошибка сервера")
            }
          })
          .finally(() => {
            this.isLoading = false
          })
    },

    async updateGenusIndex () {
      if (!this.$refs.form.validate()) throw new Error(`can't miss out on any field`)
      this.isLoading = true
      await updateGenusIndex(this.genusIndexNumber, this.genusList)
          .then((data) => {
            ToastService.toastSuccess("Индекс рода успешно обновлен")
          })
          .catch((e) => {
            if (e.response.status === 404) {
              ToastService.toastError("Ошибка сервера")
            }
          })
          .finally(() => {
            this.isLoading = false
          })
    },

    async deleteGenusIndex () {
      if (!this.$refs.form.validate()) throw new Error(`can't miss out on any field`)
      this.isLoading = true
      await deleteGenusIndex(this.genusIndexNumber)
          .then((data) => {
            ToastService.toastSuccess("Индекс рода успешно удален")
            this.reset();
            this.isGenusIndexFound = false;
          })
          .catch((e) => {
            if (e.response.status === 404) {
              ToastService.toastError("Ошибка сервера")
            }
          })
          .finally(() => {
            this.isLoading = false
            this.isDeletion = false
          })
    },

    reset () {
      this.$refs.form.reset()
    },
  }
};
</script>

<style scoped>

</style>